// import React, { useState, useRef, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import logo from "../../assets/NavLogo/BNBLOGO.png";
// import { useForm } from "react-hook-form";
// import axios from "axios";
// import toast from "react-hot-toast";
// import loginBg from "../../assets/Images/nonAuth/image.png";

// // Custom loader component
// const Loader = () => {
//   return (
//     <div className="flex justify-center">
//       <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
//     </div>
//   );
// };

// const SignIn = () => {
//   let navigate = useNavigate();
//   const { register, handleSubmit } = useForm();
//   const [loading, setLoading] = useState(false);
//   const [phone, setPhone] = useState("");
//   const [requestId, setRequestId] = useState("");
//   const [showOtpInput, setShowOtpInput] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
//   const [otpTimer, setOtpTimer] = useState(240);
//   const [timerRunning, setTimerRunning] = useState(false);
//   const API_URL = "https://bricknbar-ecom-sv0x.onrender.com/bricks-n-bar";

//   useEffect(() => {
//     let interval;
//     if (timerRunning && otpTimer > 0) {
//       interval = setInterval(() => {
//         setOtpTimer((prevTime) => prevTime - 1);
//       }, 1000);
//     } else if (otpTimer === 0) {
//       setTimerRunning(false);
//     }

//     return () => clearInterval(interval);
//   }, [timerRunning, otpTimer]);

//   const formatTime = (seconds) => {
//     const minutes = Math.floor(seconds / 60);
//     const remainingSeconds = seconds % 60;
//     return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
//       .toString()
//       .padStart(2, "0")}`;
//   };

//   const handlePhoneSubmit = (formData) => {
//     const phoneNumber = formData?.phone;
//     setPhone(phoneNumber);

//     const requestData = JSON.stringify({
//       phone: phoneNumber,
//     });

//     const config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${API_URL}/customers/send-otp`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: requestData,
//     };

//     setLoading(true);
//     axios
//       .request(config)
//       .then((response) => {
//         setLoading(false);

//         if (response?.data?.requestId) {
//           setRequestId(response?.data?.requestId);
//         }

//         toast.success("OTP sent successfully");
//         setShowOtpInput(true);
//         setOtpTimer(240);
//         setTimerRunning(true);
//       })
//       .catch((error) => {
//         setLoading(false);
//         toast.error(error.response?.data?.message || "Failed to send OTP");
//         console.error("Error:", error);
//       });
//   };

//   const handleOtpChange = (index, value) => {
//     if (value && !/^\d+$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     if (value && index < 3) {
//       inputRefs[index + 1]?.current?.focus();
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       inputRefs[index - 1]?.current?.focus();
//     }
//   };

//   // Function to fetch user data by phone number
//   const fetchUserData = async (phoneNumber) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/customers/profile?phone=${phoneNumber}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response?.data?.userData) {
//         throw new Error("User data not found");
//       }

//       return response.data.userData;
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//       throw error; // Re-throw to be handled by the caller
//     }
//   };

//   const verifyOtp = (e) => {
//     e?.preventDefault();

//     const otpValue = otp?.join("");
//     if (otpValue?.length !== 4) {
//       toast.error("Please enter a valid 4-digit OTP");
//       return;
//     }

//     setLoading(true); // Set loading to true when the request starts

//     let data = JSON.stringify({
//       phone: phone,
//       otp: otpValue,
//       requestId: requestId || "huhifehu",
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${API_URL}/customers/verify-otp`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log("response userdata", response.data);
//         // Store user data
//         localStorage.setItem(
//           "BricksNbar-Users-Data",
//           JSON.stringify(response?.data?.userData)
//         );

//         // Store token if available
//         if (response?.data?.token) {
//           localStorage.setItem("BricksNbar-authToken", response.data.token);
//         }

//         toast.success("Login successful");
//         navigate("/");
//         window.location.reload();
//       })
//       .catch((error) => {
//         console.log(error);
//         toast.error("OTP verification failed. Please try again.");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   const resendOtp = () => {
//     if (!phone) {
//       toast.error("Phone number not found");
//       return;
//     }

//     const requestData = JSON.stringify({
//       phone: phone,
//     });

//     const config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${API_URL}/customers/send-otp`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: requestData,
//     };

//     setLoading(true);
//     axios
//       .request(config)
//       .then((response) => {
//         setLoading(false);
//         if (response.data.requestId) {
//           setRequestId(response?.data?.requestId);
//         }
//         toast.success("OTP sent successfully");

//         setOtpTimer(240);
//         setTimerRunning(true);
//       })
//       .catch((error) => {
//         setLoading(false);
//         toast.error("Failed to send OTP");
//         console.error("Error:", error);
//       });
//   };

//   // Handle alternative login method (username/password)
//   const handleCredentialsLogin = async (formData) => {
//     const { identifier, password } = formData;

//     if (!identifier || !password) {
//       toast.error("Please enter both email/phone and password");
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${API_URL}/customers/user-login`,
//         {
//           identifier: identifier,
//           password: password,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response?.data?.user) {
//         localStorage.setItem(
//           "BricksNbar-Users-Data",
//           JSON.stringify(response?.data?.user)
//         );

//         if (response?.data?.token) {
//           localStorage.setItem("BricksNbar-authToken", response.data.token);
//         }

//         toast.success("Login Successful");
//         navigate("/");
//       } else {
//         throw new Error("User data not received");
//       }
//     } catch (error) {
//       toast.error(
//         error.response?.data?.message || "Login failed. Please try again."
//       );
//       console.error("Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const d = new Date();
//   let year = d.getFullYear();

//   return (
//     <React.Fragment>
//       <section
//         style={{
//           backgroundImage: `url(${loginBg})`,
//         }}
//         className="flex h-screen items-center justify-center bg-cover bg-center bg-no-repeat"
//       >
//         <div className="flex h-auto w-[90%] items-center justify-center rounded-xl bg-white px-6 py-4 sm:h-[70%] sm:w-[80%] md:h-auto md:w-2/3 lg:w-1/2 xl:w-1/3">
//           <div className="h-auto w-full">
//             <div className="mt-4 flex items-center justify-center">
//               <img src={logo} alt="logo" className="h-10 w-auto" />
//             </div>

//             {!showOtpInput ? (
//               <>
//                 <h1 className="mb-2 mt-4 text-center text-2xl font-bold tracking-wide text-gray-800">
//                   Welcome Back!
//                 </h1>

//                 <p className="text-center text-sm tracking-wide text-gray-600">
//                   Enter your phone number to receive an OTP.
//                 </p>

//                 <form
//                   onSubmit={handleSubmit(handlePhoneSubmit)}
//                   className="mt-4 space-y-6"
//                 >
//                   <div className="w-full">
//                     <label className="block font-medium tracking-wide text-gray-700 mb-2">
//                       Phone Number
//                     </label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       id="phone"
//                       {...register("phone")}
//                       placeholder="Enter Your Phone No."
//                       className="appearance-none block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-700 focus:border-primary focus:outline-none"
//                       autoFocus
//                       autoComplete="tel"
//                       required
//                     />
//                   </div>

//                   <button
//                     type="submit"
//                     className="flex h-12 w-full items-center justify-center rounded-lg bg-[#C23F00] font-semibold tracking-wide hover:bg-orange-800 text-white"
//                     disabled={loading}
//                   >
//                     {loading ? <Loader /> : "Get OTP"}
//                   </button>
//                 </form>
//               </>
//             ) : (
//               <>
//                 <h1 className="mb-2 mt-4 text-center text-2xl font-bold tracking-wide text-gray-800">
//                   Verify OTP
//                 </h1>

//                 <p className="text-center text-sm tracking-wide text-gray-500">
//                   Enter the 4-digit OTP sent to {phone}
//                 </p>

//                 <form onSubmit={verifyOtp} className="mt-8 space-y-6">
//                   <div>
//                     <label className="flex items-center justify-center font-medium tracking-wide">
//                       Enter OTP
//                     </label>
//                     <div className="mt-2 flex justify-center space-x-4">
//                       {otp.map((digit, index) => (
//                         <input
//                           key={index}
//                           ref={inputRefs[index]}
//                           type="text"
//                           maxLength={1}
//                           value={digit}
//                           onChange={(e) =>
//                             handleOtpChange(index, e.target.value)
//                           }
//                           onKeyDown={(e) => handleKeyDown(index, e)}
//                           className="h-14 w-14 rounded-lg border bg-[#f5f2f2] text-center text-xl font-bold focus:border-primary focus:bg-white focus:outline-none"
//                           autoFocus={index === 0}
//                         />
//                       ))}
//                     </div>
//                   </div>

//                   <div className="flex flex-col items-center text-center tracking-wide">
//                     {timerRunning && otpTimer > 0 ? (
//                       <div className="text-sm text-gray-600">
//                         OTP expires in{" "}
//                         <span className="font-medium text-[#C23F00]">
//                           {formatTime(otpTimer)}
//                         </span>
//                       </div>
//                     ) : (
//                       <button
//                         type="button"
//                         onClick={resendOtp}
//                         className="text-md font-medium tracking-wide text-[#C23F00] hover:underline"
//                         disabled={loading}
//                       >
//                         Resend OTP
//                       </button>
//                     )}
//                   </div>

//                   <button
//                     type="submit"
//                     className="flex h-12 w-full items-center justify-center rounded-lg bg-[#C23F00] font-semibold tracking-wide text-white hover:bg-orange-800"
//                     disabled={loading}
//                   >
//                     {loading ? <Loader /> : "Verify"}
//                   </button>
//                 </form>
//               </>
//             )}

//             <p className="mt-6 text-center text-sm tracking-wider text-gray-500">
//               &copy; {year} BricksNbar - All Rights Reserved.
//             </p>
//           </div>
//         </div>
//       </section>
//     </React.Fragment>
//   );
// };

// export default SignIn;

import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/NavLogo/BNBLOGO.png";
import { useForm } from "react-hook-form";
import axios from "axios";
import toast from "react-hot-toast";
import loginBg from "../../assets/Images/nonAuth/image.png";
import { useAuth } from "../../utils/AuthContext ";

const Loader = () => {
  return (
    <div className="flex justify-center">
      <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
    </div>
  );
};

const SignIn = () => {
  let navigate = useNavigate();
  const { login } = useAuth();
  const { register, handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [requestId, setRequestId] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [otpTimer, setOtpTimer] = useState(240);
  const [timerRunning, setTimerRunning] = useState(false);

  useEffect(() => {
    let interval;
    if (timerRunning && otpTimer > 0) {
      interval = setInterval(() => {
        setOtpTimer((prevTime) => prevTime - 1);
      }, 1000);
    } else if (otpTimer === 0) {
      setTimerRunning(false);
    }

    return () => clearInterval(interval);
  }, [timerRunning, otpTimer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handlePhoneSubmit = (formData) => {
    const phoneNumber = formData?.phone;
    setPhone(phoneNumber);

    const requestData = JSON.stringify({
      phone: phoneNumber,
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/customers/send-otp`,
      headers: {
        "Content-Type": "application/json",
      },
      data: requestData,
    };

    setLoading(true);
    axios
      .request(config)
      .then((response) => {
        setLoading(false);

        if (response?.data?.requestId) {
          setRequestId(response?.data?.requestId);
        }

        toast.success("OTP sent successfully");
        setShowOtpInput(true);
        setOtpTimer(240);
        setTimerRunning(true);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message || "Failed to send OTP");
        console.error("Error:", error);
      });
  };

  const handleOtpChange = (index, value) => {
    if (value && !/^\d+$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      inputRefs[index + 1]?.current?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs[index - 1]?.current?.focus();
    }
  };

  // Function to fetch user data by phone number
  // const fetchUserData = async (phoneNumber) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/customers/profile?phone=${phoneNumber}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (!response?.data?.userData) {
  //       throw new Error("User data not found");
  //     }

  //     return response.data.userData;
  //   } catch (error) {
  //     console.error("Error fetching user data:", error);
  //     throw error; // Re-throw to be handled by the caller
  //   }
  // };

  const verifyOtp = (e) => {
    e?.preventDefault();

    const otpValue = otp?.join("");
    if (otpValue?.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP");
      return;
    }

    setLoading(true); // Set loading to true when the request starts

    let data = JSON.stringify({
      phone: phone,
      otp: otpValue,
      requestId: requestId || "huhifehu",
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/customers/verify-otp`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("response userdata", response.data);
        // Use the context login function instead of manually setting localStorage
        login(response?.data?.userData, response?.data?.token);

        toast.success("Login successful");
        navigate("/");
        window.scrollTo({ top: 0, behavior: "smooth" });
        // No need for window.location.reload()
      })
      .catch((error) => {
        console.log(error);
        toast.error("OTP verification failed. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resendOtp = () => {
    if (!phone) {
      toast.error("Phone number not found");
      return;
    }

    const requestData = JSON.stringify({
      phone: phone,
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/customers/send-otp`,
      headers: {
        "Content-Type": "application/json",
      },
      data: requestData,
    };

    setLoading(true);
    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        if (response.data.requestId) {
          setRequestId(response?.data?.requestId);
        }
        toast.success("OTP sent successfully");

        setOtpTimer(240);
        setTimerRunning(true);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Failed to send OTP");
        console.error("Error:", error);
      });
  };

  // Handle alternative login method (username/password)
  const handleCredentialsLogin = async (formData) => {
    const { identifier, password } = formData;

    if (!identifier || !password) {
      toast.error("Please enter both email/phone and password");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/customers/user-login`,
        {
          identifier: identifier,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.user) {
        // Use the context login function
        login(response?.data?.user, response?.data?.token);

        toast.success("Login Successful");
        navigate("/");
        // No need for window.location.reload()
      } else {
        throw new Error("User data not received");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Login failed. Please try again."
      );
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const d = new Date();
  let year = d.getFullYear();

  return (
    <React.Fragment>
      <section
        style={{
          backgroundImage: `url(${loginBg})`,
        }}
        className="flex h-screen items-center justify-center bg-cover bg-center bg-no-repeat"
      >
        <div className="flex h-auto w-[90%] items-center justify-center rounded-xl bg-white px-6 py-4 sm:h-[70%] sm:w-[80%] md:h-auto md:w-2/3 lg:w-1/2 xl:w-1/3">
          <div className="h-auto w-full">
            <div className="mt-4 flex items-center justify-center">
              <img src={logo} alt="logo" className="h-16 w-auto" />
            </div>

            {!showOtpInput ? (
              <>
                <h1 className="mb-2 mt-4 text-center text-2xl font-bold tracking-wide text-gray-800">
                  Welcome Back!
                </h1>

                <p className="text-center text-sm tracking-wide text-gray-600">
                  Enter your phone number to receive an OTP.
                </p>

                <form
                  onSubmit={handleSubmit(handlePhoneSubmit)}
                  className="mt-4 space-y-6"
                >
                  <div className="w-full">
                    <label className="block font-medium tracking-wide text-gray-700 mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      id="phone"
                      {...register("phone")}
                      placeholder="Enter Your Phone No."
                      className="appearance-none block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-700 focus:border-primary focus:outline-none"
                      autoFocus
                      autoComplete="tel"
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="flex h-12 w-full items-center justify-center rounded-lg bg-[#C23F00] font-semibold tracking-wide hover:bg-orange-800 text-white"
                    disabled={loading}
                  >
                    {loading ? <Loader /> : "Get OTP"}
                  </button>
                </form>
              </>
            ) : (
              <>
                <h1 className="mb-2 mt-4 text-center text-2xl font-bold tracking-wide text-gray-800">
                  Verify OTP
                </h1>

                <p className="text-center text-sm tracking-wide text-gray-500">
                  Enter the 4-digit OTP sent to {phone}
                </p>

                <form onSubmit={verifyOtp} className="mt-8 space-y-6">
                  <div>
                    <label className="flex items-center justify-center font-medium tracking-wide">
                      Enter OTP
                    </label>
                    <div className="mt-2 flex justify-center space-x-4">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          ref={inputRefs[index]}
                          type="text"
                          maxLength={1}
                          value={digit}
                          onChange={(e) =>
                            handleOtpChange(index, e.target.value)
                          }
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          className="h-14 w-14 rounded-lg border bg-[#f5f2f2] text-center text-xl font-bold focus:border-primary focus:bg-white focus:outline-none"
                          autoFocus={index === 0}
                        />
                      ))}
                    </div>
                  </div>

                  <div className="flex flex-col items-center text-center tracking-wide">
                    {timerRunning && otpTimer > 0 ? (
                      <div className="text-sm text-gray-600">
                        OTP expires in{" "}
                        <span className="font-medium text-[#C23F00]">
                          {formatTime(otpTimer)}
                        </span>
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={resendOtp}
                        className="text-md font-medium tracking-wide text-[#C23F00] hover:underline"
                        disabled={loading}
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="flex h-12 w-full items-center justify-center rounded-lg bg-[#C23F00] font-semibold tracking-wide text-white hover:bg-orange-800"
                    disabled={loading}
                  >
                    {loading ? <Loader /> : "Verify"}
                  </button>
                </form>
              </>
            )}

            <p className="mt-6 text-center text-sm tracking-wider text-gray-500">
              &copy; {year} BricksNbar - All Rights Reserved.
            </p>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default SignIn;
